module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('h2', [_vm._v("Bricks for Bulls")]), _vm._v(" "), _c('h3', [_vm._v("Now’s the time to cement your legacy!")]), _vm._v(" "), _c('div', {
    staticClass: "font-lg"
  }, [_c('p', [_vm._v("\n                        We are currently not accepting new brick orders at this time.\n                        We appreciate your interest in supporting UB Athletics and the Bricks for Bulls campaign.\n                        We invite you to visit us at "), _c('a', {
    attrs: {
      "href": "http://www.bullsbwf.com/"
    }
  }, [_vm._v("www.BullsBWF.com")]), _vm._v(" to learn about other ways to get involved to support our 300+ student athletes.\n                        GO BULLS!\n                    ")])]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/aboutbricks.png",
      "alt": ""
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-068b44c7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = OIWi
// module chunks = 1